<template>
	<div v-if="myProjects && myProjects.length > 1" class="project-toggler dropdown">
		<!-- {{ $screen.height }} -->
		<b-dropdown class="fixed-dropdown" variant="outline-secondary" size="sm" :text="myProject ? myProject.titre : ''">
			<b-dropdown-header id="dropdown-header-label">
				{{ FormMSG(1, 'Switch to another project') }}
			</b-dropdown-header>
			<div class="px-3 py-2 search-bar-sticky">
				<b-input-group>
					<b-form-input type="text" v-model="search" :placeholder="FormMSG(4, 'Type to search ...')" />
					<b-input-group-append>
						<b-input-group-text>
							<search color="#06263E" :size="16" class="icon cursor-pointer" v-if="search.length === 0" />
							<x color="#06263E" :size="16" class="icon cursor-pointer" @click="clearSearch" v-else />
						</b-input-group-text>
					</b-input-group-append>
				</b-input-group>
			</div>
			<div v-if="filteredProjects.length > 0" class="project-list-container">
				<b-dropdown-item-button
					v-for="project in filteredProjects"
					:key="project.id"
					action
					href="#"
					:active="myProject && myProject.id === project.id"
					@click="changeProjectAction(project)"
				>
					{{ project.titre }}
				</b-dropdown-item-button>
			</div>
			<div v-else class="project-list-container">
				<b-dropdown-item-button action :active="false">
					{{ FormMSG(3, 'No projects found') }}
				</b-dropdown-item-button>
			</div>
		</b-dropdown>
	</div>
	<div v-else class="project-toggler">
		<span class="label-only">{{ myProject ? myProject.titre : '' }}</span>
	</div>
</template>

<script>
import gql from 'graphql-tag';
import { store } from '@/store';
import { myContracts } from '@/cruds/contract.crud';
// import { myProjects, myProject } from '@/cruds/project.crud.js'
import languageMessages from '@/mixins/languageMessages';
import globalMixin from '@/mixins/global.mixin';
import { getParamVersion } from '@/shared/version';
import { mapActions } from 'vuex';
import { query_myProjects, query_myProject, changeMyProject } from '@/cruds/project.crud';
import { Search, X } from 'lucide-vue';

export default {
	name: 'HeaderProjectToggler',
	mixins: [languageMessages, globalMixin],
	components: {
		Search,
		X
	},
	apollo: {
		myProjects: {
			query: query_myProjects,
			fetchPolicy: 'no-cache',
			error(err) {
				// console.log('err:', err);
				this.erreur = err;
			}
		},
		myProject: {
			query: query_myProject,
			fetchPolicy: 'no-cache',
			error(err) {
				// console.log('err:', err);
				this.erreur = err;
			}
		}
	},
	data: function () {
		return {
			// Initialize your apollo data
			myProjects: {},
			myProject: {},
			erreur: {},
			myerr: '',
			shared: store.state,
			search: ''
			// myProjects: [],
			// myProject: null
		};
	},

	computed: {
		filteredProjects() {
			return this.myProjects.filter((project) => project.titre.toLowerCase().includes(this.search.toLowerCase()));
		}
	},

	methods: {
		...mapActions({
			getNotifications: 'header/getNotifications',
			initFilterActive: 'global-filter/initFilterActive',
			getDocuments: 'document/getDocuments'
		}),
		async changeProject(project) {
			// position on dashboar screen first
			// this.$router.push("/")
			const id = parseInt(project.id, 10);
			try {
				const result = await changeMyProject(id);
				const response = await store.onNewToken(this.$apollo.provider.defaultClient, result); // executer onNewToken avant de storer le nouveau projet, sinon supprimé
				if (response) {
					store.setProjectAction(); // project parameters is not in use, removed it
					this.initFilterActive();
					const tmp = await myContracts();
					// console.log("in myContract DefaultHeaderDropdownAccnt tmp:",tmp);
					store.state.myContracts = tmp;
					this.myerr = '';

					await this.getNotifications(project.id);
					this.getDocuments({
						userId: +store.userID()
					});

					// reload project data.
					// await this.loadProjectsData();

					// refresh the page and redirect to project dashboard
					this.$router.push({ name: 'My Dashboard' }).catch(() => {
						this.$router.go();
					});
				}
			} catch (err) {
				this.erreur = err;
			}
		},
		// async loadProjectsData() {
		// 	try {
		// 		this.myProjects = await getAllMyProjectsSummary();
		// 		this.myProject = await getMyProjectSummary();
		// 	} catch (err) {
		// 		this.erreur = err;
		// 		console.log('error get project header', err);
		// 	}
		// },
		async changeProjectAction(project) {
			this.search = '';
			await this.showLoader(this.changeProject, 'default-container', false, project);
		},

		clearSearch() {
			this.search = '';
		}
	}
	// async created() {
	// 	await this.loadProjectsData();
	// }
};
</script>

<style scoped>
::v-deep .dropdown-menu {
	max-height: 650px;
	overflow-y: auto;
}

.project-toggler .dropdown-menu {
	margin: 0;
	padding: 0;
}

.project-toggler .label-only {
	color: #007949;
	font-weight: bold;
	display: inline-block;
	background-color: #eee;
	border: 1px solid #eee;
	padding: 0.25rem 0.5rem;
	font-size: 0.875rem;
	line-height: 1.5;
	border-radius: 0.2rem;
}

.fixed-dropdown >>> .dropdown-menu {
	width: 350px !important; /* Forces the dropdown width */
	max-height: 650px;
	overflow-y: auto;
}

.search-bar-sticky {
	position: sticky;
	top: 0;
	background-color: white;
	z-index: 10;
	border-bottom: 1px solid #dee2e6;
	margin-bottom: 0 !important;
}

.project-list-container {
	max-height: 400px;
	overflow-y: auto;
}
</style>
